import { InfoOutlined as InfoIcon } from '@mui/icons-material';
export const helperTextRender = (helperTextIcon?: string) => {
  if (helperTextIcon) {
    switch (helperTextIcon) {
      case 'info':
        return <InfoIcon sx={{ fontSize: '1.5rem', verticalAlign: 'middle' }} />;
      default:
        return null;
    }
  }
};
